import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=bd6f701a&scoped=true&"
import script from "./pagination.vue?vue&type=script&lang=ts&"
export * from "./pagination.vue?vue&type=script&lang=ts&"
import style0 from "./pagination.vue?vue&type=style&index=0&id=bd6f701a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f701a",
  null
  
)

export default component.exports